<div class="container">
    <div class="row justify-content-center pt-5">
        <div class="col-sm-10">
            <p>
                Cookies are small text files that can be used by websites to
                make a user's experience more efficient. This website uses
                cookies but only those cookies that are strictly necessary for
                the operation of this website. In case any other type of cookies
                would be implemented on this website we would ask for your
                permission and you will be able to change or withdraw your
                consent from the Cookie Declaration on our website at any time.
            </p>
        </div>
    </div>
</div>
